import React from 'react';

const STAR = 'M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.4L12 17.3l-5.8 3.1 1.1-6.4-4.7-4.6 6.5-.9L12 2.6z';

const Row = ({ className }) => (
  <span className={className}>
    {[0, 1, 2, 3, 4].map((i) => (
      <svg key={i} width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d={STAR} />
      </svg>
    ))}
  </span>
);

/**
 * Five stars in --mk-star. A fractional `value` (e.g. 4.3) renders the partial variant: a gold row
 * clipped to value/5 over grey stars. The whole group is one image with a spoken label.
 */
const MkStars = ({ value = 5, label, className }) => {
  const partial = value < 5;
  const aria = label || `${value} out of 5 stars`;
  const classes = ['mk-stars', partial && 'mk-stars--partial', className].filter(Boolean).join(' ');
  if (!partial) {
    return (
      <span className={classes} role="img" aria-label={aria}>
        <Row className="mk-stars__row" />
      </span>
    );
  }
  const pct = Math.max(0, Math.min(100, (value / 5) * 100));
  return (
    <span className={classes} role="img" aria-label={aria}>
      <Row className="mk-stars__row mk-stars__row--base" />
      <span className="mk-stars__fill" style={{ width: `${pct}%` }}>
        <Row className="mk-stars__row" />
      </span>
    </span>
  );
};

export default MkStars;
